export default __webpack_public_path__ + "static/imgTreepng-8ef6bd91f994614559662728e91b82a5.png";